import React from 'react';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoAutoFinanciePesado.css';
import WhiteButton from '@/components/atoms/WhiteButton';

function BancoAutoFinanciePesado() {
  return (
    <section id="banco-do-auto-financie-pesado">
      <div className="bg-vermelho" />
      <img
        className="acelerador"
        src="assets/banco-do-auto25/ic_accelerator.svg"
        alt="acelerador"
      />
      <img
        className="acelerador desktop"
        src="assets/banco-do-auto25/ic_accelerator_desktop.svg"
        alt="acelerador"
      />
      <img
        className="segundo-acelerador"
        src="assets/banco-do-auto25/ic_acelerador.svg"
        alt="acelerador"
      />
      <ContainerHome24 className="container-financie">
        <div className="container-texto">
          <p className="paragrafo">Financiamento de até</p>
          <b className="negrito">100%</b>
          <p className="paragrafo">do valor</p>
        </div>
        <img className="caminhoes" src="assets/banco-do-auto25/caminhoes.svg" alt="caminhões" />
        <div className="container-texto segundo">
          <p className="paragrafo">Financie em até</p>
          <b className="negrito">60x</b>
        </div>

        <div className="container-texto-desktop">
          <div className="content">
            <div className="container-texto terceiro">
              <b>+800 mil</b>
              <p className="paragrafo">financiamentos de veículos por ano</p>
            </div>
            <div className="container-texto terceiro">
              <b>+60 anos</b>
              <p className="paragrafo">de experiência em financiamento de veículos</p>
            </div>
            <div className="container-texto terceiro">
              <b>+25 milhões</b>
              <p className="paragrafo">de sonhos realizados com o financiamento Santander</p>
            </div>
          </div>
        </div>
        <WhiteButton className="financie-btn-white" href="credenciados.html">
          Ver lojas credenciadas
        </WhiteButton>
      </ContainerHome24>
      <img
        className="segundo-acelerador desktop"
        src="assets/banco-do-auto25/ic_acelerador-desktop.svg"
        alt="acelerador"
      />
      <style jsx>{Styles}</style>
    </section>
  );
}

export default BancoAutoFinanciePesado;
